import { UserOutlined } from '@ant-design/icons';
import { Avatar, Badge, Button, Card, Col, Row, Space, Table, Tag, Tooltip, Typography } from 'antd'
import React, { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { rightsService } from '../../../services/rightsService';
import { LOGGED_USER } from '../../../variables/constants';

const { Text, Title } = Typography;

const UtilisateursTab = ({ utilisateurs = [], colors }) => {
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 8,
        showSizeChanger: true
    });

    const navigate = useNavigate();
    const isAdminProfile = (LOGGED_USER?.profil?.nom || "").toLowerCase().includes("admin");
    const canAddUser = rightsService("HPE038") || rightsService("HPE033") || isAdminProfile;

    const getRightsList = (user) => {
        const rights = user?.profil?.habilitations || user?.habilitations || [];
        if (!Array.isArray(rights)) return [];
        return rights
            .map((h) => h?.codeHabilitation || h?.code || h)
            .filter(Boolean);
    };

    // Colonnes pour les tables
    const columnsUtilisateurs = [
        {
            title: 'Utilisateur',
            key: 'user',
            width: '35%',
            render: (_, record) => (
                <Tooltip onClick={() => navigate(`/details-utilisateur/${record.codeId}`)} title="Cliquer pour voir plus de détails">
                    <Space>
                        <Avatar style={{ backgroundColor: colors.primary }} icon={<UserOutlined />} />
                        <div>
                            <Text strong>{record?.personne?.nom} {record?.personne?.prenom}</Text>
                            <br />
                            <Text type="secondary" style={{ fontSize: '12px' }}>{record.email}</Text>
                        </div>
                    </Space>
                </Tooltip>
            )
        },
        {
            title: 'Profil',
            dataIndex: 'profil',
            key: 'profil',
            render: (profil) => <Tag color="blue">{profil?.nom}</Tag>
        },
        {
            title: 'Agence',
            dataIndex: 'agence',
            key: 'agence',
            render: (agence) => agence?.nom || 'N/A'
        },
        {
            title: 'Statut',
            key: 'statut',
            render: (_, record) => (
                <Badge
                    status={record.active ? "success" : "error"}
                    text={record.active ? "Actif" : "Inactif"}
                />
            )
        },
        // {
        //     title: 'Actions',
        //     key: 'actions',
        //     render: (_, record) => (
        //         <Button onClick={() => navigate(`/details-utilisateur/${record.codeId}`)} type="primary" size="small" style={{ backgroundColor: colors.primary, borderColor: colors.primary }}>
        //             Voir
        //         </Button>
        //     )
        // }
    ];

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
                <Space>
                    {canAddUser && (
                        <Button
                            type="primary"
                            icon={<UserOutlined />}
                            size="large"
                            style={{
                                borderRadius: '10px',
                                backgroundColor: colors.primary,
                                borderColor: colors.primary,
                                fontWeight: 500
                            }}
                            onClick={() => navigate(`/ajouter-utilisateur`)}
                        >
                            Ajouter un utilisateur
                        </Button>
                    )}
                </Space>
            </div>
            <Table
                columns={columnsUtilisateurs}
                dataSource={utilisateurs}
                pagination={pagination}
                onChange={(pg) => setPagination(pg)}
                style={{ borderRadius: '8px' }}
            />
        </div>
    )
}

export default UtilisateursTab
